import React from 'react';
import ContactModal from "../ContactModal";
import {Link} from "react-router-dom";

function Avis() {

    return (
            <section className="avis layout-pt-20 layout-pb-40 text-center" style={{background: "#E81F76"}}>
                <div className="auto-container">
                    <div className="text-left btn-lahalle">
                        <h2 className="libre-title raleway" style={{textTransform: "uppercase"}}>
                            Hotline Handicap: Votre avis compte !
                        </h2>

                        <div className="text mt-15 mb-2 nunito">
                            En quelques mots, contribuez à faire évoluer la Hotline Handicap et à renforcer l’inclusion chez Incluvia 🤍
                        </div>

                        <a
                            href="https://tally.so/r/w206Ve"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="theme-btn btn-style-six mt-3 small"
                        >
                            Je donne mon avis
                        </a>
                    </div>
                    </div>
            </section>
);
}

export default Avis;
